import { HttpParams } from '@angular/common/http';

/** Valid types for HTTP query parameter values */
export type HttpParamValue = string | number | boolean | null | undefined;

/** Object that can be converted to HTTP query parameters */
export type HttpParamsObject = {
  [key: string]: HttpParamValue | HttpParamValue[];
};

/**
 * Convert object to HttpParams, filtering out null/undefined/empty values
 */
export function toHttpParams(obj: object): HttpParams {
  let params = new HttpParams();

  Object.keys(obj).forEach((key) => {
    const value = (obj as Record<string, unknown>)[key] as HttpParamValue | HttpParamValue[];

    // Skip null, undefined, or empty (trimmed) string
    if (
      value === null ||
      value === undefined ||
      (typeof value === 'string' && value.trim().length === 0)
    ) {
      return;
    }

    // If the value is an array, append each item
    if (Array.isArray(value)) {
      value.forEach((val: HttpParamValue) => {
        // Skip null, undefined, or empty (trimmed) strings inside arrays
        if (
          val === null ||
          val === undefined ||
          (typeof val === 'string' && val.trim().length === 0)
        ) {
          return;
        }

        params = params.append(key, val.toString().trim());
      });
    } else {
      params = params.set(key, value.toString().trim());
    }
  });

  return params;
}
